export const m2l0Solution = `%lang starknet

// Starknet provides persistent and mutable storage
// do not modify code on this line or above

// TODO: Create a storage named 'bool' storing a single felt
// Help: See https://www.cairo-lang.org/docs/hello_starknet/more_features.html#storage-variable-with-multiple-values for reference

@storage_var
func bool() -> (val: felt) {
}

// do not modify code on this line or below

from starkware.cairo.common.cairo_builtins import HashBuiltin

@external
func test_store_bool{syscall_ptr : felt*, pedersen_ptr : HashBuiltin*, range_check_ptr}() {
    let (x) = bool.read();
    assert x = 0;

    bool.write(1);

    let (x) = bool.read();
    assert x = 1;

    return();
}`;
